(ns bp-libs.design-system.components.keyboard
  (:require [bp-libs.design-system.components.icons :as icons]))

(def ^:private hover-classes
  "cursor-pointer hover:bg-gray-50 hover:text-gray-900 focus:bg-gray-50 focus:text-gray-900")

(defn- keyboard-letter [{:keys [on-item-click tab-index]} letter]
  [:div {:class ["bg-gray-900 outline-none"
                 "rounded"
                 "h-16 w-16 mb-2 mr-2"
                 "flex justify-center items-center"
                 hover-classes]
         :tab-index tab-index
         :on-click #(on-item-click letter)}
   [:span {:class "selection:bg-none"} letter]])

(def ^:private lower-case-alphabet-ascii-codes (range 97 123))
(def ^:private numbers-ascii-codes (concat (range 49 58) '(48)))
(def ^:private keyboard-letters (mapv char (concat lower-case-alphabet-ascii-codes numbers-ascii-codes)))

(defn keyboard
  {:storybook {}}
  [{:keys [on-item-click tab-index] :as props}]
  [:div {:class ["w-full text-gray-50 font-semibold text-xl flex flex-col"]}
   (into [:div {:class ["flex flex-wrap justify-content-end mx-1"]}]
         (mapv (partial keyboard-letter props) keyboard-letters))
   [:div {:class ["flex space-x-2 mr-5 ml-1"]}
    [:div {:class ["bg-gray-900 outline-none"
                   "rounded"
                   "h-16 w-full"
                   "flex justify-center items-center"
                   hover-classes]
           :tab-index tab-index
           :on-click #(on-item-click " ")}
     [:div {:class ["w-6"]}
      [icons/space {:width "100%"
                    :height "100%"}]]]
    [:div {:class ["bg-gray-900 outline-none"
                   "rounded"
                   "h-16 w-full"
                   "flex justify-center items-center"
                   hover-classes]
           :tab-index tab-index
           :on-click #(on-item-click :backspace)}
     [:div {:class ["w-6"]}
      [icons/backspace {:width "100%"
                        :height "100%"}]]]]
   [:div {:class ["flex flex-col mt-2 mr-5 ml-1"]}
    [:div {:class ["bg-gray-900 outline-none"
                   "rounded"
                   "h-16"
                   "flex justify-center items-center"
                   hover-classes]
           :tab-index tab-index
           :on-click #(on-item-click :clean-all)}
     [:span "Limpar tudo"]]]])
